<app-popup-container>
    <app-popup-content *ngIf="data.mediaData !== undefined">
        <mm-media [autoplay]="false"
                  [mediaData]="data.mediaData"
                  [size]="'insidePopup'"
                  class="pa-image"></mm-media>
    </app-popup-content>
</app-popup-container>
